
export const ELECTRONIC_BRANDS: string[] = [
    'Apple', 'Samsung', 'Xiaomi', 'Huawei', 'Oppo', 'Realme', 'Vivo', 'OnePlus',
    'Google', 'Sony', 'LG', 'Nokia', 'Motorola', 'Asus', 'Lenovo',
    'Nothing', 'Tecno', 'Infinix', 'Honor', 'Fairphone', 'ZTE', 'Alcatel',
    'CAT', 'Blackview', 'UMIDIGI', 'Doogee', 'XOR', 'Reeder', 'General Mobile', 'Casper'
];

export const COMPUTER_BRANDS: string[] = [
    'Apple', 'Lenovo', 'Dell', 'HP', 'Asus', 'Acer', 'MSI', 'Monster', 'Huawei', 'Casper', 'Toshiba', 'Fujitsu', 'Gigabyte'
];

export const PRINTER_BRANDS: string[] = [
    'HP', 'Canon', 'Epson', 'Brother', 'Xerox', 'Samsung', 'Lexmark', 'Oki', 'Pantun', 'Ricoh'
];

export const GAMING_BRANDS: string[] = [
    'Sony', 'Microsoft', 'Nintendo', 'Sega', 'Atari', 'Valve', 'Razer', 'SteelSeries', 'Logitech', 'MSI', 'Asus ROG'
];

export const AV_BRANDS: string[] = [
    'Sony', 'Samsung', 'LG', 'Philips', 'Bose', 'JBL', 'Sennheiser', 'Bang & Olufsen', 'Harman Kardon', 'Marshall', 'Xiaomi', 'Apple', 'Beats'
];

export const WATCH_BRANDS: string[] = [
    'Apple Watch', 'Samsung Galaxy Watch', 'Garmin', 'Fitbit', 'Huawei Watch', 'Xiaomi Mi Band', 'Amazfit', 'Withings', 'Victorinox', 'Hamilton',
    'Breitling', 'IWC', 'Panerai', 'Audemars Piguet', 'Patek Philippe', 'Vacheron Constantin', 'Jaeger-LeCoultre', 'Hublot', 'Richard Mille',
    'Frederique Constant', 'Rado', 'Baume & Mercier', 'Bell & Ross', 'Oris', 'Nomos', 'Junghans', 'Mido', 'Raymond Weil'
];

export const SMARTPHONE_MODELS: Record<string, string[]> = {
    'Apple': [
        'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
        'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
        'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13', 'iPhone 13 mini',
        'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12', 'iPhone 12 mini',
        'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11',
        'iPhone SE (2022)', 'iPhone SE (2020)', 'iPhone SE (2016)',
        'iPhone XR', 'iPhone XS Max', 'iPhone XS', 'iPhone X',
        'iPhone 8 Plus', 'iPhone 8', 'iPhone 7 Plus', 'iPhone 7'
    ],
    'Samsung': ['Galaxy S24 Ultra', 'Galaxy S24+', 'Galaxy S24', 'Galaxy Z Fold5', 'Galaxy Z Flip5', 'Galaxy A54', 'Galaxy A34'],
    'Xiaomi': ['Redmi Note 13 Pro+', 'Redmi Note 13 Pro', 'Xiaomi 13T Pro', 'Xiaomi 13T', 'POCO X6 Pro', 'POCO M6 Pro'],
    'Google': ['Pixel 8 Pro', 'Pixel 8', 'Pixel 7a', 'Pixel Fold', 'Pixel 7 Pro', 'Pixel 7'],
    'Nothing': ['Phone (2)', 'Phone (1)'],
    'Realme': ['GT 5 Pro', 'GT Neo5', '11 Pro+', 'C55'],
    'OnePlus': ['12', '12R', 'Open', 'Nord 3'],
    'Honor': ['Magic 6 Pro', 'Magic V2', '90 Lite', 'X9b'],
    'Asus': ['ROG Phone 8 Pro', 'Zenfone 10', 'Zenfone 11 Ultra']
};

export const TABLET_MODELS: Record<string, string[]> = {
    'Apple': ['iPad Pro 12.9 (2024)', 'iPad Pro 11 (2024)', 'iPad Air (2024)', 'iPad 10.9 (2022)', 'iPad mini 8.3'],
    'Samsung': ['Galaxy Tab S9 Ultra', 'Galaxy Tab S9+', 'Galaxy Tab S9', 'Galaxy Tab A9+', 'Galaxy Tab Active5'],
    'Xiaomi': ['Pad 6', 'Pad 6 Pro', 'Pad 5'],
    'Lenovo': ['Tab P12 Pro', 'Tab M10 Plus', 'Yoga Tab 13'],
    'Huawei': ['MatePad Pro 13.2', 'MatePad 11.5S', 'MatePad SE'],
    'Microsoft': ['Surface Pro 10', 'Surface Go 4'],
    'Amazon': ['Fire Max 11', 'Fire HD 10']
};

export const SMARTWATCH_MODELS: Record<string, string[]> = {
    'Apple Watch': ['Series 9', 'Ultra 2', 'SE (2022)', 'Series 8'],
    'Samsung Galaxy Watch': ['Watch6 Classic', 'Watch6', 'Watch5 Pro'],
    'Garmin': ['Fenix 7', 'Venu 3'],
    'Fitbit': ['Charge 6', 'Sense 2']
};

export const CONSOLE_MODELS: Record<string, string[]> = {
    'Sony': ['PlayStation 5 (Disk)', 'PlayStation 5 (Digital)', 'PlayStation 4 Pro', 'PlayStation 4 Slim', 'PlayStation 4', 'PS Vita', 'PSP'],
    'Microsoft': ['Xbox Series X', 'Xbox Series S', 'Xbox One X', 'Xbox One S', 'Xbox One', 'Xbox 360'],
    'Nintendo': ['Switch OLED', 'Switch', 'Switch Lite', 'Wii U', 'Wii', '3DS', '2DS']
};
